import axios from '../../../axios'

export const getOrderUseStat = (data) => {
  return axios({
    url: '/stat/orderUse/getOrderUseStat',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/biz/stat/statOrderUse.js